/**
 * Entry point for the Cookie Declaration widget bundle.
 * Self-initializes on load.
 */
import { initDeclarationWidget } from "./DeclarationWidget";

initDeclarationWidget();
